import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

interface IUpdateData {
  model?: string;
  year?: string;
  licensePlate?: string;
  payloadCapacity?: string;
  vehicleTypeId?: string;
  dimensions?: {
    length: number;
    width: number;
    weight: number;
  };
  crlv?: {
    crlvId?: string;
    documentNumber: string;
    expirationDate: string;
    isDigital: boolean;
    imageUrlFront: File | null;
    imageUrlBack: File | null;
  },
  images?: {
    imageUrlFront: File | null;
    imageUrlBack: File | null;
    imageUrlLeft: File | null;
    imageUrlRight: File | null;
  }
  driverId?: string;
  distributorId?: string;
}

const getPersistedToken = (): string => {
  try {
    const persistFretapp = localStorage.getItem('persist:fretapp');
    if (persistFretapp) {
      const parsedRoot = JSON.parse(persistFretapp);
      const distributorString = parsedRoot.distributor;
      if (distributorString) {
        const distributor = JSON.parse(distributorString);
        return distributor?.token || '';
      }
    }
  } catch (error) {
    console.error('[getPersistedToken] Erro ao recuperar token:', error);
  }
  return '';
};

export default function useUpdatePrivateVehicleData() {
  const [loading, setLoading] = useState(false);

  async function execute(vehicleId: string, data: IUpdateData, callback?: any) {
    try {
      setLoading(true);

      const token = getPersistedToken();
      const authHeaders = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await api.put(
        `v1/api/vehicles/${vehicleId}/backoffice`,
        data,
      );

      if (data.crlv && (data.crlv.imageUrlFront instanceof File || data.crlv.imageUrlBack instanceof File)) {
        const uploadCrlvImage = async (
          file: File | string | null,
          endpointSuffix: string,
          fieldName: string,
        ) => {
          if (file instanceof File) {
            const formData = new FormData();
            formData.append(fieldName, file);
            const crlvUploadUrl = `/v1/api/vehicles/${vehicleId}/crlv/${data.crlv!.crlvId}/${endpointSuffix}`;

            await api.put(crlvUploadUrl, formData, {
              ...authHeaders,
              headers: {
                ...authHeaders.headers,
                'Content-Type': 'multipart/form-data',
              },
            });
          }
        };

        if (data.crlv.imageUrlFront instanceof File) {
          await uploadCrlvImage(
            data.crlv.imageUrlFront,
            'image-front',
            'crlvFrontImage',
          );
        }
        if (data.crlv.imageUrlBack instanceof File) {
          await uploadCrlvImage(
            data.crlv.imageUrlBack,
            'image-back',
            'crlvBackImage',
          );
        }
      }

      if (response.status === 200) {
        toast.success(ToastMessages.vehicle.success.update);
        if (callback) {
          callback();
        }
      }
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || ToastMessages.vehicle.error.update;

      if (Array.isArray(errorMessage)) {
        errorMessage.map((msg: string) =>
          toast.error(`Erro de validação: ${msg}`),
        );
      } else {
        toast.error(`Erro: ${errorMessage}`);
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}